import Api from '../api';

export interface BiddingFileResponse {
  id: string;
  filename: string;
  path?: string | null;
  size?: number | null;
  modified_at?: string | null;
  source?: string | null;
  archive?: string | null;
  download_url: string;
}

export interface BiddingFilesResponse {
  files: BiddingFileResponse[];
}

export type BidderFileCategory =
  | 'impugnacao'
  | 'esclarecimento'
  | 'proposta'
  | 'habilitacao'
  | 'recursos';

export type BidderFileStatus = 'pending' | 'processing' | 'completed' | 'error';

export interface BidderFileResponse {
  id: string;
  filename: string;
  source: string;
  source_label: string;
  status: BidderFileStatus;
  category?: BidderFileCategory | null;
  category_label?: string | null;
  // Só nos arquivos do Preparar Proposta: os da última geração registrada x versões anteriores.
  generation?: 'latest' | 'previous' | null;
  generated_at?: string | null;
  requirement_title?: string | null;
  download_url: string;
}

export type BidderFileSource =
  | 'relatorio_licitante'
  | 'manifestacao_contratual'
  | 'historico_contratacao'
  | 'possiveis_concorrentes'
  | 'preparar_proposta';

export type BidderFileGeneratedHandler = (
  source: BidderFileSource,
  file: Blob,
  filename: string,
) => void;

export interface BidderFilesResponse {
  files: BidderFileResponse[];
}

export const listBiddingFiles = (biddingId: number) =>
  Api.get<BiddingFilesResponse>(`/gestao_ia/licitacoes/${biddingId}/arquivos`);

export const listBidderFiles = (biddingId: number) =>
  Api.get<BidderFilesResponse>(`/gestao_ia/licitacoes/${biddingId}/arquivos/licitante`);

export const uploadBidderFile = (
  biddingId: number,
  source: BidderFileSource,
  file: Blob,
  filename: string,
  category?: BidderFileCategory,
) => {
  const formData = new FormData();
  formData.append('source', source);
  if (category) formData.append('category', category);
  formData.append('file', file, filename);
  return Api.post<{ file: BidderFileResponse }>(
    `/gestao_ia/licitacoes/${biddingId}/arquivos/licitante`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
};

export const downloadBiddingFile = (downloadUrl: string) =>
  Api.get<Blob>(downloadUrl, { params: { preview: true }, responseType: 'blob' });

export const biddingFileHref = (downloadUrl: string) =>
  `${process.env.REACT_APP_API_ENDPOINT}${downloadUrl}`;
